/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Flyerdialogdescription2Inputs */

const en_flyerdialogdescription2 = /** @type {(inputs: Flyerdialogdescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The QR code on the flyer points directly to ${i?.name}.`)
};

const de_flyerdialogdescription2 = /** @type {(inputs: Flyerdialogdescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Der QR-Code auf dem Flyer verweist direkt auf ${i?.name}.`)
};

/**
* | output |
* | --- |
* | "The QR code on the flyer points directly to {name}." |
*
* @param {Flyerdialogdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerdialogdescription2 = /** @type {((inputs: Flyerdialogdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerdialogdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerdialogdescription2(inputs)
	return de_flyerdialogdescription2(inputs)
});
export { flyerdialogdescription2 as "flyerDialogDescription" }